module.exports = __webpack_public_path__ + "static/media/33.eaa1804a.jpg";